import { render, staticRenderFns } from "./VersionPage.vue?vue&type=template&id=db15cdea&scoped=true&lang=pug&"
import script from "./VersionPage.vue?vue&type=script&lang=ts&"
export * from "./VersionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db15cdea",
  null
  
)

export default component.exports